import { createFileRoute } from "@tanstack/react-router";
import AISpacedRepetitionGuide from "@/pages/resources/AISpacedRepetitionGuide";

export const Route = createFileRoute("/learn/ai-spaced-repetition")({
  head: () => ({
    meta: [
        {
            "title": "AI-Powered Spaced Repetition: How It Works | System Atlas"
        },
        {
            "name": "description",
            "content": "How AI improves spaced repetition with automatic scheduling (SM-2), quiz-driven reviews, and gap analysis. Complete guide to AI-powered long-term retention."
        },
        {
            "property": "og:title",
            "content": "AI-Powered Spaced Repetition: How It Works | System Atlas"
        },
        {
            "property": "og:description",
            "content": "How AI improves spaced repetition with automatic scheduling (SM-2), quiz-driven reviews, and gap analysis. Complete guide to AI-powered long-term retention."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/ai-spaced-repetition"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "AI-Powered Spaced Repetition: How It Works | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "How AI improves spaced repetition with automatic scheduling (SM-2), quiz-driven reviews, and gap analysis. Complete guide to AI-powered long-term retention."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/ai-spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/ai-spaced-repetition"
        }
    ],
  }),
  component: AISpacedRepetitionGuide,
});
